document.querySelectorAll(".new-stores-tab-li").forEach(function(item){
  item.addEventListener("click", function(e){
    e.currentTarget.closest(".new-stores-wrapper").querySelectorAll(".new-stores-swiper, .new-stores-mobile-flex-wrapper").forEach(function(sw){
      sw.classList.remove("active");
    })
    e.currentTarget.closest(".new-stores-wrapper").querySelectorAll(".new-stores-tab-li").forEach(function(sw){
      sw.classList.remove("active");
    })
    let title = e.currentTarget.dataset.title;
    e.currentTarget.classList.add("active");
    e.currentTarget.closest(".new-stores-wrapper").querySelector(`.new-stores-swiper[data-title="${title}"]`).classList.add("active");
    e.currentTarget.closest(".new-stores-wrapper").querySelector(`.new-stores-mobile-flex-wrapper[data-title="${title}"]`).classList.add("active");
  })
})

document.querySelectorAll(".new-instagram-tab-li").forEach(function(item){
  item.addEventListener("click", function(e){
    e.currentTarget.closest(".new-instagram-wrapper").querySelectorAll(".new-instagram-swiper-wrapper").forEach(function(sw){
      sw.classList.remove("active");
    })
    e.currentTarget.closest(".new-instagram-wrapper").querySelectorAll(".new-instagram-tab-li").forEach(function(sw){
      sw.classList.remove("active");
    })
    let title = e.currentTarget.dataset.title;
    e.currentTarget.classList.add("active");
    e.currentTarget.closest(".new-instagram-wrapper").querySelector(`.new-instagram-swiper-wrapper[data-title="${title}"]`).classList.add("active");
    window.dispatchEvent(new Event('resize'));
  })
})

var _sgInitialized = new WeakSet();

function configureInlineVideo(video) {
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  video.setAttribute('muted', '');
  video.muted = true;
  video.removeAttribute('autoplay');
  video.pause();
}
function configureInlineVideos(root) {
  if (root instanceof HTMLVideoElement) {
    configureInlineVideo(root);
  }
  if (root.querySelectorAll) {
    root.querySelectorAll('video').forEach(configureInlineVideo);
  }
}

function initShowcaseGalleries() {
  document.querySelectorAll('.sg-section').forEach(function(sectionEl) {
    if (_sgInitialized.has(sectionEl)) return;
    _sgInitialized.add(sectionEl);

    var loadedWrappers = new Set();
    var videoConfigured = new WeakSet();

    // Watch for video elements being added anywhere in the document and configure them for inline playback
    var videoObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'VIDEO') {
            if (!videoConfigured.has(node)) {
              configureInlineVideos(node);
              videoConfigured.add(node);
            }
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('video').forEach(function(video) {
              if (!videoConfigured.has(video)) {
                configureInlineVideos(video);
                videoConfigured.add(video);
              }
            });
          }
        });
      });
    });
    videoObserver.observe(document.body, { childList: true, subtree: true });
    configureInlineVideos(document);

    function loadGalleriesForWrapper(wrapper) {
      if (loadedWrappers.has(wrapper)) return;
      var loaders = wrapper.querySelectorAll('.sg-gallery-loader');
      loaders.forEach(function(loader) {
        var script = document.createElement('script');
        script.src = loader.getAttribute('data-src');
        script.async = true;
        var attrs = loader.attributes;
        for (var i = 0; i < attrs.length; i++) {
          var name = attrs[i].name;
          if (name !== 'data-src') {
            script.setAttribute(name, attrs[i].value);
          }
        }
        loader.parentNode.appendChild(script);
      });
      loadedWrappers.add(wrapper);
    }

    // MutationObserver: load immediately when tab becomes active (user clicked)
    var tabObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var target = mutation.target;
          if (target.classList.contains('new-instagram-swiper-wrapper') && target.classList.contains('active')) {
            loadGalleriesForWrapper(target);
          }
        }
      });
    });

    sectionEl.querySelectorAll('.new-instagram-swiper-wrapper').forEach(function(wrapper) {
      tabObserver.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
      loadGalleriesForWrapper(wrapper);
    });

    sectionEl.addEventListener('shopify:section:unload', function() {
      tabObserver.disconnect();
      videoObserver.disconnect();
      loadedWrappers.clear();
    });
  });
}

document.querySelectorAll(".f-mobile-nav__sub-link").forEach(function(item){
  item.addEventListener("click", function(e){
    if(e.currentTarget.getAttribute("href").indexOf("#") != -1){
      e.currentTarget.closest(".f-mobile-nav").querySelector(".f-drawer__close").dispatchEvent(new Event("click"));
    }
  })
})

function getCart() {
  return fetch("/cart.js").then(r => r.json());
}

function globalCartNoteController() {
  const allowedAttr = document.body.getAttribute("data-allowed-product-ids") || "";
  const allowedIds = allowedAttr.split(",").map(id => id.trim());

  return getCart().then(cart => {
    const allowedInCart = cart.items.some(item =>
      allowedIds.includes(String(item.product_id))
    );
    if (allowedInCart) {
      const component = document.querySelector("cart-note-dropdowns");
      let noteText = "";
      if (component) {
        noteText = [...component.querySelectorAll("select")]
          .map(dd => dd.value ? `${dd.dataset.label}: ${dd.value}` : "")
          .filter(Boolean)
          .join(" | ");
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: noteText })
        });
      }
    } else {
      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: "" })
      });
    }
  });
}

// Keeps one membership line at qty 1: the priciest, ties go to the newest (cart.items[0])
function reconcileMembershipCart(retriesLeft = 5) {
  const membershipIds = (document.body.dataset.allowedProductIds || "").split(",");
  return getCart().then(cart => {
    const lines = cart.items.filter(item => membershipIds.includes(String(item.product_id)));
    const keep = lines.reduce((best, item) => item.original_price > best.original_price ? item : best, lines[0]);
    const updates = {};
    lines.forEach(item => {
      const quantity = item === keep ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    if (!Object.keys(updates).length) return;
    const sections = [
      ...(document.querySelector("cart-drawer")?.getSectionsToRender().map(section => section.id) || []),
      ...(document.querySelector("cart-items")?.getSectionsToRender().map(section => section.section) || [])
    ];
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates, sections, sections_url: window.location.pathname })
    })
      .then(response => {
        if (!response.ok) throw new Error("Membership cart update failed");
        return response.json();
      });
  }).catch(() => retriesLeft && new Promise(resolve => setTimeout(resolve, 500)).then(() => reconcileMembershipCart(retriesLeft - 1)));
}

// Redraws cart views with the fixed cart without opening the drawer
function reconcileAndRenderMembershipCart() {
  return reconcileMembershipCart().then(state => state && window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, { ...state, source: "membership-reconcile" }));
}

window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, () => reconcileAndRenderMembershipCart());
document.addEventListener("cart:refresh", () => reconcileAndRenderMembershipCart());

document.addEventListener("DOMContentLoaded", () => {
  reconcileAndRenderMembershipCart();
  globalCartNoteController();
  document.addEventListener("product-ajax:added", () => {
    setTimeout(globalCartNoteController, 500);
  });
  document.addEventListener("cart:updated", () => {
    setTimeout(globalCartNoteController, 500);
  });
});
class CartNoteDropdowns extends HTMLElement {
  connectedCallback() {
    this.dropdowns = this.querySelectorAll("select");
    this.dropdowns.forEach(dd => {
      dd.addEventListener("change", () => this.tryUpdate());
    });
    this.tryUpdate();
  }

  tryUpdate() {
    const allowedAttr = document.body.getAttribute("data-allowed-product-ids") || "";
    const allowedIds = allowedAttr.split(",").map(id => id.trim());
    getCart().then(cart => {
      const allowedInCart = cart.items.some(item =>
        allowedIds.includes(String(item.product_id))
      );
      if (allowedInCart) {
        this.updateNote();
      }
    });
  }

  updateNote() {
    const formatted = [...this.dropdowns]
      .map(dd => dd.value ? `${dd.dataset.label}: ${dd.value}` : "")
      .filter(Boolean)
      .join(" | ");
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: formatted })
    });
  }
}

customElements.define("cart-note-dropdowns", CartNoteDropdowns);

window.FoxThemeEvents.subscribe(
  PUB_SUB_EVENTS.optionValueSelectionChange,
  ({ data }) => {
    const { event, target, selectedOptionValues } = data;
    let hasLineItems = false;
    document.querySelectorAll("product-info .variant-picker__input input[type=radio]:checked").forEach(function(opt){
      let val = opt.value.toLowerCase().trim();
      if(val == 'engraving - yes'){
        hasLineItems = true;
      }
    })
    if(hasLineItems){
      if(document.querySelectorAll("product-info product-form .new-pdp-line-item-field").length){
        document.querySelectorAll("product-info product-form .new-pdp-line-item-field").forEach(function(item){
          item.value = "";
          item.setAttribute("required", "");
        });
        document.querySelector(".new-pdp-line-items-wrapper").style.display = "block";
      }
    }
    else{
      if(document.querySelectorAll("product-info product-form .new-pdp-line-item-field").length){
        document.querySelectorAll("product-info product-form .new-pdp-line-item-field").forEach(function(item){
          item.value = "";
          item.removeAttribute("required");
        });
        document.querySelector(".new-pdp-line-items-wrapper").style.display = "none";
      }
    }
  }
);

function sortByLastName(container) {
  const cards = Array.from(container.children).filter(child => child.hasAttribute("data-name"));

  cards.sort((a, b) => {
    const getLastName = el => {
      const parts = el.getAttribute('data-name').split(' ');
      return parts[parts.length - 1].toLowerCase();
    };
    return getLastName(a).localeCompare(getLastName(b));
  });

  cards.forEach(card => container.appendChild(card));
  container.setAttribute("data-sort-lastname", "true");
}

function sortByDate(container, childSelector) {
  const cards = Array.from(container.querySelectorAll(childSelector));

  cards.sort((a, b) => {
    const dateA = new Date(a.dataset.date || 0);
    const dateB = new Date(b.dataset.date || 0);
    return dateB - dateA;
  });

  cards.forEach(card => container.appendChild(card));
  container.setAttribute("data-sort-date", "true");
}

// =============================
// SWIPER HELPER
// =============================

function initSwiper(swiperEl) {
  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  let shadowRoot = swiperEl.shadowRoot;
  // if (shadowRoot && !shadowRoot.querySelector('style[data-custom]')) {
  //   let style = document.createElement('style');
  //   style.setAttribute('data-custom', '');
  //   style.textContent = `
  //     .swiper-pagination-total {
  //       display: none;
  //     }
  //   `;
  //   shadowRoot.appendChild(style);
  // }

  Object.assign(swiperEl, {
    grid: { rows: 1, fill: 'row' },
    breakpoints: {
      0: {
        grid: { rows: parseFloat(swiperEl.getAttribute('grid-row-mobile')) || 1, fill: 'row' }
      },
      768: {
        grid: { rows: parseFloat(swiperEl.getAttribute('grid-row')) || 1, fill: 'row' }
      }
    }
  });

  swiperEl.initialize();
}

// =============================
// INIT
// =============================

function initAll() {
  initShowcaseGalleries();
  // 1. sort by last name
  document.querySelectorAll('[data-sort-lastname]').forEach(container => {
    sortByLastName(container);
  });

  // 2. sort by date
  document.querySelectorAll('[data-sort-date]').forEach(container => {
    const childSelector = container.tagName.toLowerCase() === 'swiper-container'
      ? 'swiper-slide'
      : '.announcement_card';
    sortByDate(container, childSelector);
  });

  // 3. init swiper if the container tag is swiper-container
  document.querySelectorAll('[data-sort-lastname], [data-sort-date]').forEach(container => {
    if (container.tagName.toLowerCase() === 'swiper-container') {
      initSwiper(container);
    }
  });
}

document.addEventListener('DOMContentLoaded', initAll);
document.addEventListener('shopify:section:load', initAll);
document.addEventListener('shopify:section:reorder', initAll);

// --- Shopify Theme Editor: Scroll Swiper to selected block ---
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:block:select', function(e) {
    const blockId = e.detail && e.detail.blockId;
    if (!blockId) return;
    const slide = document.querySelector('.new-slider-swiper .block_' + blockId);
    if (!slide) return;
    const swiperContainer = slide.closest('swiper-container');
    if (swiperContainer && swiperContainer.swiper) {
      const slides = Array.from(swiperContainer.querySelectorAll('swiper-slide'));
      const index = slides.indexOf(slide);
      if (index !== -1) swiperContainer.swiper.slideTo(index);
    }
  });
}


class CustomAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleToggle();
    this.handleFilter();
  }

  handleToggle(e) {
    this.addEventListener("click", (event) => {
      if (!(this.querySelector(".collapsible_tab_header") instanceof HTMLElement) || !(this.querySelector(".collapsible_tab_content") instanceof HTMLElement)) return console.log("Malformed Accordion");
      if (!this.querySelector(".collapsible_tab_header").contains(event.target)) return;
      
      if (this.querySelector(".collapsible_tab_header").getAttribute("aria-expanded") === "true") {
        this.querySelector(".collapsible_tab_header").setAttribute("aria-expanded", "false");
      } else {
        this.querySelector(".collapsible_tab_header").setAttribute("aria-expanded", "true");
      }
    });
  }

  handleFilter() {
    const filterButtons = this.querySelectorAll("[data-filter-role]");
    if(filterButtons.length){
      filterButtons.forEach(button => {
        button.addEventListener("click", (e) => {
          filterButtons.forEach(btn => btn.classList.remove("active"));
          button.classList.add("active");
          const role = button.getAttribute("data-filter-role");
          const cards = button.closest(".card_container").querySelectorAll(".profile_card");
          cards.forEach(card => {
            const toggleElement = card.closest("swiper-slide") || card;
            if(role === "all" || card.dataset.role === role){
              toggleElement.style.display = "block";
            }
            else{
              toggleElement.style.display = "none";
            }
            e.target.closest(".card_container").querySelector("swiper-container")?.swiper.update();
          })
        });
      });
    }
  }
}
customElements.define("custom-accordion", CustomAccordion);

document.querySelectorAll(".new-faq-title").forEach(function(item){
  item.addEventListener("click", function(e){
    e.currentTarget.classList.toggle("active");
  })
})
document.querySelectorAll(".new-faq-load-more").forEach(function(button){
  button.addEventListener("click", function(){
    button.closest(".new-faq").querySelectorAll(".new-faq-item[hidden]").forEach(function(item){ item.hidden = false; });
    button.remove();
  })
})